export default "__VITE_ASSET__CgHYbR5e__"